"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATETIME_HUGE_WITH_SECONDS = exports.DATETIME_HUGE = exports.DATETIME_FULL_WITH_SECONDS = exports.DATETIME_FULL = exports.DATETIME_MED_WITH_WEEKDAY = exports.DATETIME_MED_WITH_SECONDS = exports.DATETIME_MED = exports.DATETIME_SHORT_WITH_SECONDS = exports.DATETIME_SHORT = exports.TIME_24_WITH_LONG_OFFSET = exports.TIME_24_WITH_SHORT_OFFSET = exports.TIME_24_WITH_SECONDS = exports.TIME_24_SIMPLE = exports.TIME_WITH_LONG_OFFSET = exports.TIME_WITH_SHORT_OFFSET = exports.TIME_WITH_SECONDS = exports.TIME_SIMPLE = exports.DATE_HUGE = exports.DATE_FULL = exports.DATE_MED_WITH_WEEKDAY = exports.DATE_MED = exports.DATE_SHORT = void 0;
/**
* format like 10/14/1983
*/
exports.DATE_SHORT = "DATE_SHORT";
/**
* format like 'Oct 14, 1983'
*/
exports.DATE_MED = "DATE_MED";
/**
* format like 'Fri, Oct 14, 1983'
*/
exports.DATE_MED_WITH_WEEKDAY = "DATE_MED_WITH_WEEKDAY";
/**
* format like 'October 14, 1983'
*/
exports.DATE_FULL = "DATE_FULL";
/**
* format like 'Tuesday, October 14, 1983'
*/
exports.DATE_HUGE = "DATE_HUGE";
/**
* format like '09:30 AM'. Only 12-hour if the locale is.
*/
exports.TIME_SIMPLE = "TIME_SIMPLE";
/**
* format like '09:30:23 AM'. Only 12-hour if the locale is.
*/
exports.TIME_WITH_SECONDS = "TIME_WITH_SECONDS";
/**
* format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
*/
exports.TIME_WITH_SHORT_OFFSET = "TIME_WITH_SHORT_OFFSET";
/**
* format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
*/
exports.TIME_WITH_LONG_OFFSET = "TIME_WITH_LONG_OFFSET";
/**
* format like '09:30', always 24-hour.
*/
exports.TIME_24_SIMPLE = "TIME_24_SIMPLE";
/**
* format like '09:30:23', always 24-hour.
*/
exports.TIME_24_WITH_SECONDS = "TIME_24_WITH_SECONDS";
/**
* format like '09:30:23 EDT', always 24-hour.
*/
exports.TIME_24_WITH_SHORT_OFFSET = "TIME_24_WITH_SHORT_OFFSET";
/**
* format like '09:30:23 Eastern Daylight Time', always 24-hour.
*/
exports.TIME_24_WITH_LONG_OFFSET = "TIME_24_WITH_LONG_OFFSET";
/**
* format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
*/
exports.DATETIME_SHORT = "DATETIME_SHORT";
/**
* format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
*/
exports.DATETIME_SHORT_WITH_SECONDS = "DATETIME_SHORT_WITH_SECONDS";
/**
* format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
*/
exports.DATETIME_MED = "DATETIME_MED";
/**
* format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
*/
exports.DATETIME_MED_WITH_SECONDS = "DATETIME_MED_WITH_SECONDS";
/**
* format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
*/
exports.DATETIME_MED_WITH_WEEKDAY = "DATETIME_MED_WITH_WEEKDAY";
/**
* format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale i
*/
exports.DATETIME_FULL = "DATETIME_FULL";
/**
* format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
*/
exports.DATETIME_FULL_WITH_SECONDS = "DATETIME_FULL_WITH_SECONDS";
/**
* format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
*/
exports.DATETIME_HUGE = "DATETIME_HUGE";
/**
* format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
*/
exports.DATETIME_HUGE_WITH_SECONDS = "DATETIME_HUGE_WITH_SECONDS";
